module.exports = __webpack_public_path__ + "d99305a4e31e13b7ce93a12dcc182908.png";